// extracted by mini-css-extract-plugin
export default {"textAreaContainer":"TextArea_textAreaContainer__o8s7N","label":"TextArea_label__aXTa1","textArea":"TextArea_textArea__EKbYc"};